import { TransitionType } from "@fartherfinance/frontend/api/TransitionWorkflows/Types";

const TRANSITIONS_DEFAULT_PAGE = 1;
const TRANSITIONS_DEFAULT_PAGE_SIZE = 20;

// TODO: add transitions status filter
export const TRANSITIONS_DEFAULT_QUERY_PARAMS = {
  page: TRANSITIONS_DEFAULT_PAGE,
  pageSize: TRANSITIONS_DEFAULT_PAGE_SIZE,
};

// Transition type mapping and options
const transitionTypeMap: Record<TransitionType, string> = {
  MasterMerge: "Merge",
  LPOA: "LPOA",
  ACAT: "ACATS Repaper",
};

export const transitionTypeOptions: { label: string; value: TransitionType }[] =
  Object.entries(transitionTypeMap).map(([value, label]) => ({
    label,
    value: value as TransitionType,
  }));
